import { TilesRenderer } from '3d-tiles-renderer/three';
import { Box3, Camera } from 'three';

import { applyScreenFractionError, LodTile, ViewErrorTarget } from './tiles-lod';

/**
 * TilesRenderer that can select the LOD by how much of a tile's loaded content is in view, see
 * applyScreenFractionError.
 */
export class ScreenFractionTilesRenderer extends TilesRenderer {
  /**
   * Content bounds in the tiles group frame for every tile that has been loaded. They are kept after a tile is
   * evicted from the cache: otherwise an evicted ancestor would stop refining, making all of its descendants unused so
   * they get evicted, and the ancestor gets reloaded, refines and is evicted again in an endless loop.
   */
  readonly contentBounds = new Map<LodTile, Box3>();

  /** Select the LOD by the visible fraction of the content, otherwise the library's screen-space error is used. */
  useScreenFraction = false;

  /** Tiles that haven't loaded yet are not loaded while less than this fraction of them is in view. */
  minLoadVisibleFraction = 0;

  calculateTileViewError(tile: LodTile, target: ViewErrorTarget) {
    // calculateTileViewError isn't part of the library's typings.
    const prototype = TilesRenderer.prototype as unknown as {
      calculateTileViewError(tile: LodTile, target: ViewErrorTarget): void;
    };
    prototype.calculateTileViewError.call(this, tile, target);

    if (!this.useScreenFraction) {
      return;
    }

    applyScreenFractionError(tile, target, {
      contentBounds: this.contentBounds,
      cameras: (this as unknown as { cameras: Camera[] }).cameras,
      group: this.group,
      minLoadVisibleFraction: this.minLoadVisibleFraction,
    });
  }
}
